import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const navigate = useNavigate();

  const login = (data) => {
    // Spremamo točno ono što tvoj API šalje
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("user_id", data.user_id);
    localStorage.setItem("name", data.name);
    localStorage.setItem("email", data.email);
    localStorage.setItem("tvrtka_id", data.tvrtka_id);
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const isAuthenticated = !!localStorage.getItem("access_token");

  return { login, logout, isAuthenticated };
};

export default useAuth;